@import 'styles/mixins';

.prediction {
  .fakeAssistantCursor {
    .label {
      font-size: 12px;
      background: #923dff;
      padding: 0 2px;
      color: white;
      position: absolute;
      transform: translateY(-100%);
      &::before {
        content: '';
        width: 1px;
        height: 100%;
        background: #923dff;
        position: absolute;
        top: 100%;
        left: 0;
      }
    }
  }
}
